import { createFileRoute } from '@tanstack/react-router';

import { TechnologicalTransferBrowse } from '@/module/Author/TechnologicalTransfer';

export const Route = createFileRoute('/_auth/author/_author/technological-transfer/_technologicalTransfer/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TechnologicalTransferBrowse />;
}
